import {Button} from '@vector';
import styles from './VideoSection.module.css';

/**
 * Same native `<video>` markup as `Home.js`/the original `sections` video - deliberately not
 * touched (no HLS, no swap to the Video.js-based `VideoPlayer.js`). Only the surrounding section,
 * heading and gallery-link chrome are restyled.
 */
export default function VideoSection({content}) {
    const words = content.heading.trim().split(' ');
    const highlight = words.pop();
    const lead = words.join(' ');

    return (
        // The id is the target of Cambridge LANTITE Edge's "Overview" link.
        <section id="ch-home-video" className={styles.section} aria-labelledby="home-video">
            <div className={styles.inner}>
                <h2 id="home-video" className={styles.heading}>
                    {lead} <span className={styles.highlight}>{highlight}</span>
                </h2>
                {/* Optional: Edjin's introduces the video. */}
                {content.standfirst && <p className={styles.standfirst}>{content.standfirst}</p>}

                <div className={styles.videoFrame}>
                    {content.youtubeId ? (
                        // A video on YouTube (Cambridge LANTITE Edge's overview), from its no-cookie domain so
                        // nothing is set until the viewer plays it.
                        <iframe src={`https://www.youtube-nocookie.com/embed/${content.youtubeId}`}
                                title={content.title} loading="lazy"
                                allow="encrypted-media; picture-in-picture; fullscreen" allowFullScreen/>
                    ) : (
                        <video controls preload="none" poster={content.poster}>
                            {content.sources.map((source) => (
                                <source key={source.src} src={source.src} type={source.type}/>
                            ))}
                            Your browser cannot play this video.
                        </video>
                    )}
                </div>

                {/* Optional: India's page has the video alone, without the AU gallery and webinars. */}
                {content.galleryHref && (
                    <div className={styles.actions}>
                        <Button surface="base" size="large" href={content.galleryHref} target="_blank"
                                rel="noopener noreferrer">
                            {content.actionLabel}
                        </Button>
                        <p className={styles.hint}>{content.webinarNote}</p>
                    </div>
                )}
            </div>
        </section>
    );
}
